import AXIOS from '@/utils/$axios';

// 查询图片原始文件地址
export const commentAdjunctView = data =>
    AXIOS.post('/space/project/project-drawing/comment-adjunct-view', data);

// 上传
export const uploadFile = payload => {
    return AXIOS.post('/space/common/upload', payload);
};

// 通过 sourceCode 获取模型或者材质详情

export const getDetailBySourceCode = data =>
    AXIOS.post('/lws/model/info', data);

// hdd 客户最新下载地址

export const getHddDownloadUrl = data =>
    AXIOS.post('/lws/install-package/get-trial-version', data);
